import React from "react";
import { graphql } from "gatsby";
import { ComparisonTable } from "./ComparisonTable";
import {
  KontentComponentLayout,
  KontentComponentSettings,
  KontentLinkedVectorArt,
  KontentRichText,
  StringValue,
} from "../../../types";
import { getComponentSettings } from "../../../lib/componentSettings";
import { formatVector } from "../../../lib/images";

interface Props extends KontentComponentLayout, KontentComponentSettings {
  heading: StringValue;
  text: KontentRichText;
  table: KontentRichText;
  background_vector: KontentLinkedVectorArt;
  right_vector: KontentLinkedVectorArt;
}

const ComparisonTableContainer: React.FC<Props> = ({
  heading,
  text,
  table,
  background_vector,
  right_vector,
  ...props
}) => {
  const settings = getComponentSettings({ ...props });
  const backgroundVector = formatVector(background_vector?.value[0]?.elements);
  const rightVector = formatVector(right_vector?.value[0]?.elements);

  return (
    <ComparisonTable
      heading={heading?.value}
      text={text?.value !== "<p><br></p>" ? text : undefined}
      backgroundVector={backgroundVector}
      rightVector={rightVector}
      table={table}
      {...settings}
    ></ComparisonTable>
  );
};

export default ComparisonTableContainer;

export const fragmentComparisonTableContainer = graphql`
  fragment ComparisonTable on kontent_item_comparison_table {
    elements {
      heading {
        value
      }
      text {
        ...kontentSimpleRichText
      }
      table {
        ...kontentSimpleRichText
      }
      right_vector {
        value {
          ...kontentVectorArt
        }
      }
      background_vector {
        value {
          ...kontentVectorArt
        }
      }
      component_settings__hide_on_mobile {
        value {
          codename
        }
      }
      component_settings__anchor_name {
        value
      }
      component_layout__component_width {
        value {
          codename
        }
      }
    }
  }
`;
